<template>
  <slick
    ref="carousel"
    class='carousel'
    v-bind:options="slickOptions"
    v-on:beforeChange="forwardBeforeChange"
  >
    <slot></slot>
  </slick>
</template>

<script>
import Slick from 'vue-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

export default {
  name: 'SgVueSlickCarousel', // sg is an alias for stylegold
  props: {
    'infinite': {
      type: Boolean,
      default: true
    },
    'adaptiveHeight': {
      type: Boolean,
      default: true
    }
  },
  components: {Slick},
  data: function () {
    return {
      slickOptions: {
        arrows: true,
        dots: true,
        fade: false,
        adaptiveHeight: this.adaptiveHeight,
        infinite: this.infinite,
        lazyLoad: 'ondemand'
      }
    }
  },
  methods: {
    reInit: function () {
      this.$refs.carousel.reSlick()
    },
    forwardBeforeChange: function (event, slick, oldSlideIndex, newSlideIndex) {
      this.$emit('before-change', oldSlideIndex, newSlideIndex)
    }
  }
}
</script>

<style scoped lang="scss">
  $pagination-margin: 35px;
  $nav-buttons-size: 30px;

  .carousel {
    display: inline-block;
    width: 100%;

    &.slick-slider {
      -ms-touch-action: pan-y pinch-zoom;
      touch-action: pan-y pinch-zoom;
    }
    &.slick-dotted.slick-slider {
      margin-bottom: $pagination-margin;
    }

    & >>> img {
      display: block;
      width: 100%;
      position: relative;
      &.slick-loading {
        visibility: hidden;
      }
    }
    & >>> .slick-list {
      transition: height 0.5s ease-in-out;
    }
    & >>> .slick-prev {
      left: (-1.25 * $nav-buttons-size);
    }
    & >>> .slick-next {
      right: (-1.25 * $nav-buttons-size);
    }
    & >>> .slick-arrow.slick-prev,
    & >>> .slick-arrow.slick-next {
      width: $nav-buttons-size;
      height: $nav-buttons-size;
      &:before {
        font-size: $nav-buttons-size;
        transition: opacity 0.3s ease;
      }
      @include media ("<=mobile") {
        display: none !important;
      }
    }
    & >>> .slick-dots {
      bottom: (-1 * $pagination-margin);
      height: 20px;
      li {
        margin: 0 7.5px;
        button:before {
          font-size: 15px;
          color: $active-link-color;
          transition: opacity 0.3s ease;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/the-content/utils/SgVueSlickCarousel.vue